const input = {
    username: "Ім'я користувача",
    password: 'Пароль',
    email: 'Електронна пошта',
    phone_number: 'Номер телефону',
    confirm_password: 'Підтвердити пароль',
    search_region_code: 'Пошук коду регіону',
    backup_code: 'Резервний код',
    label_with_optional: "{{label}} (Необов'язково)",
};
export default Object.freeze(input);
